import moment from 'moment';

export const EDIT_LOCK_HOURS = 48;

// Public holidays with no drivers available, as [month (1-12), day] — repeats every year.
const BLOCKED_DATES = [[1, 1], [1, 26], [4, 25], [12, 24], [12, 25], [12, 26], [12, 31]];

export function isBookableDate(date) {
	const month = date.getMonth() + 1;
	const day = date.getDate();
	return !BLOCKED_DATES.some(([m, d]) => m === month && d === day);
}

export function canEditBooking(booking) {
	const pickup = moment(booking.booking_date, 'YYYY-MM-DD HH:mm:ss');
	if (!pickup.isValid()) return false;
	return pickup.diff(moment(), 'hours', true) >= EDIT_LOCK_HOURS;
}
